import { Component } from '@angular/core';

@Component({
  selector: 'app-perda-documentos',
  templateUrl: './perda-documentos.component.html',
  styleUrls: ['./perda-documentos.component.scss']
})
export class PerdaDocumentosComponent { }
